export default __webpack_public_path__ + "static/media/cogwheel_white.3191e910.svg";